import { useContext } from 'react';

import { MobileMenuContext } from '@/shared/lib/contexts';

export function useMobileMenu() {
    return useContext(MobileMenuContext);
}
